/**
 * 会員生協
 */
export class CoopModel {

  /** 会員生協コード. */
  CoopCode: string;

  /** 会員生協名. */
  CoopName: string;

  /** 会員生協名. */
  PlanCoopName: string;

  /** 会員生協短縮名. */
  CoopShortName: string;

  /** 会員生協コード名. */
  CoopCodeName: string;

}
